export default "__VITE_ASSET__a74ddc3d__"